module.exports = __webpack_public_path__ + "static/media/Deer_3.55909879.jpg";